import React from 'react'
import config from '../config.json'
import { storesAPI } from '../api'
import { Context as AuthContext } from './Auth'

const _source = () => {return window.localStorage.getItem(config.storeName)}

export 
    const Context =  React.createContext({
        current:null,
        store:null,
        loading:true,
        stores: [],
        recall: false,
        setRecall: () => {},
        detail: () => {},
        selectStore: () => {},
        addStore: () => {},
        assert: () => {},
        create: () => {},
        update: () => {},
    })

export 
    function Provider({source, ...rest}){
        const {auth} = React.useContext(AuthContext)
        const [store, setStore] = React.useState(false)
        const [loading, setLoading] = React.useState(true)
        const [current, setCurrent] = React.useState(true)
        React.useEffect(() => {
            let currentStore
            try{
                currentStore = source?source(store):_source()
            }
            catch{
                currentStore = false
            }
            if(auth){
                storesAPI.list((fetchedStores) => {
                    setStores(fetchedStores)
                    const actualStore = fetchedStores.find(s => s.name == currentStore)
                    setStore(actualStore)
                })
            }
        }, [auth])
        
        React.useEffect(() => {
            if(auth)
                setLoading(false)
        }, [store])

        const [stores, setStores] = React.useState([])

        const [recall, setRecall] = React.useState(false)

        const loadStore = (storeToLoad) => {
            console.log({storeToLoad})
            localStorage.setItem(config.storeName, storeToLoad.name)
            setStore(storeToLoad)
        }

        const selectStore = (storeSelected) => {
            const newStore = stores.find(s => s.name == storeSelected)
            if(newStore){
                loadStore(newStore)
            }
        }

        const create = (store) => {
            storesAPI.create(store, (createdStore) => {
                setStores([...stores, createdStore])
                loadStore(createdStore)
            })
            setRecall(false)
        }
        const update = (storeName, store) => {
            storesAPI.update(storeName, store, (updatedStore) => {
                setStores(stores.map(s => s.name === updatedStore.name?updatedStore:s))
            })
            setRecall(false)
        }

        const detail = (store) => {
            setCurrent(store)
        }

        const assert = () => {
            if(store)
                setStore({...store})
        }
        
        return (
            <Context.Provider value={{store, loading, stores, recall, setRecall, selectStore, create, detail, current, update, assert}}>
                {rest.children}
            </Context.Provider>
        )
    }